/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerResponse } from '../../models/customer-response';

export interface SetActiveCustomer_2$Params {
  customerId: number;
  isActive: boolean;
}

export function setActiveCustomer_2(http: HttpClient, rootUrl: string, params: SetActiveCustomer_2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
  const rb = new RequestBuilder(rootUrl, setActiveCustomer_2.PATH, 'put');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('isActive', params.isActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerResponse>;
    })
  );
}

setActiveCustomer_2.PATH = '/api/customer/{customerId}/setactive={isActive}';
